/**
 * Domain types for the rotation controller.
 *
 * Three identity layers are kept distinct throughout (spec section 8):
 *  - ParticipantId: the organiser's stable event identifier from the import.
 *  - RuntimeId:     whatever identifier the meeting platform exposes right now.
 *  - Binding:       the controller's own record linking the two, refreshed at
 *                   every main-session checkpoint.
 */
export const MAIN = 'MAIN';
//# sourceMappingURL=types.js.map